<template>
  <div class="indyApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul>
      <li>
        <span>头像</span>
        <div>
          <i class="el-icon-arrow-right"></i>
          <el-image class="right" :src="userData.avatar" fit="fill">
            <div slot="placeholder" class="image-slot">
              <span class="dot"><i class="el-icon-loading"></i></span>
            </div>
          </el-image>
        </div>
      </li>
      <li>
        <span>姓名</span>
        <div>
          <i class="el-icon-arrow-right"></i>
          <p>{{userData.username}}</p>
        </div>
      </li>
      <li>
        <span>手机号</span>
        <div>
          <p style="color:#999;padding-right:15px"><input type="text"  v-model="tel" v-if="userData.phone == ''" placeholder="请输入手机号码" style="height:30px;border:none;text-align:right;outline:none"><font v-if="userData.phone != ''">{{userData.phone}}</font></p>
        </div>
      </li>
      <!--<li>
        <span>角色</span>
        <div>
          <p style="color:#999;padding-right:15px">{{setUser.role == 1 ? '运营商' : setUser.role == 2 ? '投资商' : setUser.role == 3 ? '业务员' : (setUser.role == 4 && setUser.status1 == 0) ? '经销商' : '会员'}}</p>
        </div>
      </li>-->
      <li>
        <span>加入时间</span>
        <div>
          <p style="color:#999;padding-right:15px">{{userData.createtime}}</p>
        </div>
      </li>
    </ul>
    <div class="outLogin" @click="save">保存</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setUser:[],
        tel:''
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      save:function(){
        var that = this;
        that.fullscreenLoading = true;
        this.axios({
          'url': that.$host+'home/user/saveUser',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            phone:(that.userData.phone == '' ? that.tel :that.userData.phone)
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          that.$router.back()
          localStorage.setItem('userjwt', JSON.stringify(response.data.data));
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .indyApp{
    max-width:640px;
    background:#fff;
    margin:0 auto;
  }
  .indyApp ul{
    background:#fff;
    width:100%;
  }
  .indyApp ul li{
    width:100%;
    height:55px;
    position:relative;
    line-height:55px;
  }
  .indyApp ul li:after{
    position:absolute;
    width:94%;
    right:0;
    bottom:0px;
    content:"";
    height:1px;
    background:#ededed
  }
  .indyApp ul li span{
    float:left;
    margin-left:6%;
    font-size:16px;
    width:20%;
  }
  .indyApp ul li div{
    float:right;
    width:70%;
    height:55px;
    line-height:55px;
  }
  .indyApp ul li div .right{
    width:35px;
    height:35px;
    margin-top:10px;
    border-radius:5px;
    float:right;
    margin-right:5px;
  }
  .indyApp ul li i{
    float:right;
    font-size:20px;
    margin-top:19px;
    margin-right:10px;
  }
  .indyApp ul li p{
    color:#555;
    font-size:16px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align:right;
  }

  .indyApp .outLogin{
    display:block;
    width:92%;
    height:40px;
    background: #da0000;
    color:#fff;
    text-align:center;
    line-height:40px;
    border-radius: 40px;
    margin:50px auto 0 auto;
    font-size:16px;
  }
</style>